const PowerLinesMenuIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Power line poles */}
      <rect x="3" y="2" width="1" height="20" fill="currentColor" />
      <rect x="11" y="2" width="1" height="20" fill="currentColor" />
      <rect x="19" y="2" width="1" height="20" fill="currentColor" />

      {/* Power lines */}
      <path
        d="M4 6 Q7.5 8 11 6 Q15.5 8 19 6"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M4 10 Q7.5 12 11 10 Q15.5 12 19 10"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M4 14 Q7.5 16 11 14 Q15.5 16 19 14"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />

      {/* IoT devices - small circles on the lines */}
      <circle cx="6" cy="7" r="1.5" fill="currentColor" />
      <circle cx="9" cy="7.5" r="1.5" fill="currentColor" />
      <circle cx="13" cy="11" r="1.5" fill="currentColor" />
      <circle cx="16" cy="11.5" r="1.5" fill="currentColor" />
      <circle cx="7" cy="15" r="1.5" fill="currentColor" />
      <circle cx="15" cy="15.5" r="1.5" fill="currentColor" />
    </svg>
  );
};

export default PowerLinesMenuIcon;
